import type { SharingMetadata } from '../../types';

export const buildSharingLabel = (
  sharing?: SharingMetadata | null,
  translate?: (key: string, fallback?: string) => string,
): string => {
  if (!sharing) {
    return '';
  }
  if (sharing.sharedByMe) {
    return translate ? translate('sharing.sharedByMe', 'Shared by me') : 'Shared by me';
  }
  if (sharing.sharedWithMe) {
    return translate ? translate('sharing.sharedWithMe', 'Shared with me') : 'Shared with me';
  }
  return translate ? translate('sharing.onlyMine', 'Only mine') : 'Only mine';
};

export const sharingBadgeClass = (sharing?: SharingMetadata | null): string => {
  if (!sharing) {
    return '';
  }
  if (sharing.sharedWithMe) {
    return 'shared-with-me';
  }
  if (sharing.sharedByMe) {
    return 'shared-by-me';
  }
  return '';
};
